import React, { CSSProperties, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ModalManager } from '../../models/ModalManager';
import { ModalBody, ModalHeading } from './common';
import { Routes } from '../../constants';

const handleLaterBtnClick = () => {
  ModalManager.closeModal();
};

const UploadUnlockedModal: React.FC = () => {
  const history = useHistory();
  const handleUploadBtnClick = useCallback(() => {
    ModalManager.closeModal();
    history.push(Routes.score);
  }, [history]);

  return (
    <ModalBody>
      <ModalHeading>Upload unlocked!</ModalHeading>
      <p>Upload your pair of photos and find out which one gets more love.</p>
      <button className={'nes-btn is-error'} style={buttonsStyle} onClick={handleUploadBtnClick}>
        Upload my photos
      </button>
      <button className={'nes-btn'} style={buttonsStyle} onClick={handleLaterBtnClick}>
        Upload later
      </button>
    </ModalBody>
  );
};

const buttonsStyle: CSSProperties = {
  margin: '20px',
};

export default UploadUnlockedModal;
